import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicSharedModule } from '../../../ionic-shared.module';
import { AuthService } from '../../../services/auth.service';
import { DateUtilsService } from '../../../services/date-utils.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
import { LoadingController, AlertController, NavController, IonModal, ModalController, IonPopover, IonInput } from '@ionic/angular';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Capacitor } from '@capacitor/core';
import { environment } from './../../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { NgxCroppedEvent } from '../../../component/ngx-photo-editor/ngx-photo-editor.component';
import { DataURIToBlob, blobToBase64 } from '../../../utils'
import { UserService } from '../../../services/user.service';
import { User } from '../../../models/user';
import { Animal, AnimalWeight, AnimalTag } from '../../../models/animal';
import { AgendaEvent, AgendaEventReport } from '../../../models/agenda';
import { NetworkService } from '../../../services/network.service';
import { AnimalService } from '../../../services/animal.service';
import { AgendaService } from '../../../services/agenda.service';
import { AnyObject } from 'chart.js/dist/types/basic';
import { FileCameraComponent } from '../../../component/file-camera/file-camera.component';
import Quill from 'quill';
import Delta from 'quill-delta';
import { QuillModule } from 'ngx-quill';
import { ComptaService } from 'src/app/services/compta.service';

@Component({
  selector: 'event-fiche',
  templateUrl: './event-fiche.component.html',
  styleUrls: ['./event-fiche.component.scss'],
  imports: [IonicSharedModule],
})
export class EventFicheComponent  implements OnInit {
  @ViewChild('modalDisplayDocument', { static: false }) modalDisplayDocument!: IonModal;

  @Input() event: AgendaEvent | null = null;
  @Output() closeEvent = new EventEmitter<any>();

  loading: HTMLIonLoadingElement | null = null;
  modalDisplayDocumentDocument: { [key: string]: any } | null = null;
  modalDisplayDocumentDocumentBase64: string | null = null
  now: Date = new Date()

  constructor(
    private http: HttpClient,
    public dateUtils: DateUtilsService,
    private authService: AuthService,
    private navCtrl: NavController,
    public loadingController: LoadingController,
    private translate: TranslateService,
    public fb: FormBuilder,
    public alertController: AlertController,
    private activatedRoute: ActivatedRoute,
    public userService: UserService,
    public networkService: NetworkService,
    public agendaService: AgendaService,
    public animalService: AnimalService,
    public modalController: ModalController,
    public router: Router,
    public comptaService: ComptaService) { }

  ngOnInit() {}

  async presentLoading(label = null) {
    if(this.loading)
      this.stopLoading();

    this.loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: label ? label: this.translate.instant('Please wait...'),
      duration: 60000
    });
    await this.loading.present();
  }

  stopLoading() {
    this.loading?.dismiss();
    this.loading = null;
  }

  async setModalDisplayDocumentDocument(document: { [key: string]: any }) {
    this.modalDisplayDocumentDocument = document;
    if(document['fileName'].toLowerCase().endsWith('.pdf')) {
      this.modalDisplayDocumentDocumentBase64 = null

      var headers = new HttpHeaders({
        'content-type': 'application/json'
      });
      var formData = {
        'type': document['base64'] ? 'base64': 'url',
        'base64': document['base64'],
        'url': document['file'],
      }
      await this.presentLoading();
      this.http.post(environment.API_URL + '../ws_public/getImageBase64FromPDF/', JSON.stringify(formData), {headers : headers}).subscribe(async (data: { [key: string]: any }) => { 
          this.modalDisplayDocumentDocumentBase64 = data['base64']
          this.loading?.dismiss()
      }, async error => {
        this.loading?.dismiss()
        var alert = await this.alertController.create({
          header: this.translate.instant("Error"),
          subHeader: this.translate.instant("Invalid file"),
          message: this.translate.instant("The PDF file is invalid or too large.") ,
          buttons: ['OK'],
        });
        await alert.present();
      });
    } else {
      if(document['base64']) {
        this.modalDisplayDocumentDocumentBase64 = document['base64']
      } else {
        this.modalDisplayDocumentDocumentBase64 = document['file']
      }
    }
  }

  getReportOfAnimal(event: AgendaEvent, animal: Animal): AgendaEventReport | null {
    for(let report of event.reports) {
      if(report.id && report.animal?.id == animal.id) {
        return report
      }
    }
    return null;
  }

  update() {
    this.router.navigate(['/event-update', this.event?.id]);
  }

  report() {
    this.router.navigate(['/event-report', this.event?.id]);
  }

  async enclose() {
    if(this.event == null)
      return

    if(this.event?.type?.isTreatment) {
      const alert = await this.alertController.create({
        header: this.translate.instant('End of treatment'),
        message: this.translate.instant('Is your pet\'s treatment complete? Is he feeling better?'),
        buttons: [ {
          text: this.translate.instant("The treatment is not complete"),
          handler: () => { } },
          {
            text: this.translate.instant("The treatment failed"),
            handler: async () => {
              if(this.event) {
                this.event.dateTimeEnd = this.dateUtils.toStringIso(new Date())
                this.event.treatmentIsSuccess = false;
                this.encloseExecute()
              }
            }
          },
          {
            text: this.translate.instant("The treatment is a success"),
            handler: async () => {
              if(this.event) {
                this.event.dateTimeEnd = this.dateUtils.toStringIso(new Date())
                this.event.treatmentIsSuccess = true;
                this.encloseExecute()
              }
            } 
          } ]
      });
      await alert.present();
    } else {
      this.encloseExecute()
    }
  }

  async encloseExecute() {
    if(this.event == null)
      return

    this.event.statut = this.agendaService.agendaEventStatuts.find(a => a.id == 'done') ?? null

    await this.presentLoading();
    this.agendaService.dbSaveEvent(this.event).then(async (data) => {
    }).finally(() => {
      this.stopLoading();
    });
  }
}
